// import i18n from '@/plugins/i18n'

export default [

]
